













































import { computed, defineComponent } from '@vue/composition-api';
import { i18n } from './../../../../i18n';
import { useInjectAbTest } from '@tt4b/ttam-hooks';
import InputTooltip from '@/components/common/input-tooltip/index.vue';

const name = 'ttam-tracking-url-setting';

export default defineComponent({
  name,
  components: {
    InputTooltip,
  },
  props: {
    showsClickTrack: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    trackUrl: { type: String, default: '' },
    trackUrlRules: { type: Array, default: () => [] },
    trackUrlTitle: { type: String, default: i18n.t('adgroup_track_url') },
    trackUrlPlaceholder: {
      type: String,
      default: i18n.t('module_enter_impression_tracking'),
    },
    actionTrackUrl: { type: String, default: '' },
    actionTrackUrlRules: { type: Array, default: () => [] },
    actionTrackUrlTitle: {
      type: String,
      default: i18n.t('adgroup_action_track_url'),
    },
    actionTrackUrlTitleTip: {
      type: String,
      default: i18n.t('adgroup_track_url_tooltip_hint'),
    },
    actionTrackUrlPlaceholder: {
      type: String,
      default: i18n.t('module_enter_click_tracking'),
    },
    isDisabledCreative: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const { isInputUrlIterationTooltipTest } = useInjectAbTest();
    const _trackUrl = computed({
      get: () => props.trackUrl,
      set: val => ctx.emit('tracking-url-change', val),
    });

    const _actionTrackUrl = computed({
      get: () => props.actionTrackUrl,
      set: val => ctx.emit('action-tracking-url-change', val),
    });

    return {
      name,
      _trackUrl,
      _actionTrackUrl,
      isInputUrlIterationTooltipTest,
    };
  },
});
